<template>
  <div class="swipe-prompt" :class="{ 'swipe-prompt--show': visible }">
    <div class="swipe-prompt__left">
      <template v-if="!usingKeys">
        <svg class="swipe-prompt__left-hand" viewBox="0 0 89 70">
          <path
            d="M81.3551 19.4175C81.4722 19.533 81.4722 19.6493 81.4722 19.7647C81.8241 20.6909 90.1549 43.6101 88.8643 56.2272C88.7472 57.5006 87.6906 58.4268 86.3999 58.4268H86.165C84.7573 58.3113 83.8186 57.1534 83.9355 55.7646C85.1091 44.8836 77.7169 23.9323 76.8952 21.733C76.3083 20.8068 75.1355 19.1864 73.493 19.6498C72.7891 19.8816 72.3193 20.2288 71.9674 20.9232C71.6155 21.5021 71.4984 22.1965 71.7325 22.8909L73.1402 27.637C73.4921 28.9103 72.7883 30.2991 71.4976 30.6464C70.2069 30.9936 68.7992 30.2992 68.4472 29.0259L67.0395 24.2798C66.9224 24.048 66.9224 23.8171 66.8046 23.4691C66.6875 23.3536 66.6875 23.2373 66.6875 23.0064L65.7488 19.8809C65.5139 19.1865 65.1619 18.723 64.4581 18.3758C63.8713 18.0286 63.1674 17.9131 62.4635 18.1441C61.7597 18.3758 61.2899 18.723 60.938 19.4174C60.586 19.9963 60.469 20.6907 60.7031 21.3851L61.4069 23.9317L63.4015 30.4137C63.7534 31.6871 63.0496 33.0758 61.7589 33.4231C61.524 33.5386 61.2899 33.5386 61.055 33.5386C59.9992 33.5386 59.0605 32.8442 58.7086 31.8026L55.0715 19.6482C54.8366 18.9538 54.4847 18.4904 53.7808 18.1432C53.194 17.796 52.4901 17.6805 51.7863 17.9114C50.4956 18.2586 49.6747 19.6474 49.9088 20.9208L53.311 32.3807C53.6629 33.654 52.959 35.0428 51.6684 35.3901C50.3777 35.7373 48.97 35.0429 48.618 33.7696L40.6398 7.03041C40.4049 6.33601 40.053 5.87254 39.3491 5.52536C38.7623 5.17817 38.0584 5.0627 37.3546 5.29363C36.6507 5.52536 36.1809 5.87256 35.829 6.56696C35.4771 7.26136 35.36 7.8403 35.5941 8.53468L47.0924 47.0807C47.4444 48.1223 46.9754 49.2803 46.0366 49.859C45.0979 50.438 43.8071 50.3217 43.1033 49.5118L32.4259 39.4414C31.8391 38.8625 31.2523 38.6308 30.6663 38.6308C30.0795 38.6308 29.4926 38.978 29.1407 39.3252C28.5539 40.0196 29.0237 41.8718 30.0795 43.4923C30.5485 44.1867 42.5165 60.3928 51.9032 65.4856C53.0769 66.18 53.5458 67.5687 52.842 68.7267C52.373 69.5373 51.5513 70 50.7304 70C50.3785 70 49.9087 69.8845 49.5568 69.6528C39.1142 63.9807 26.5597 46.965 26.0904 46.2705C23.5091 42.566 23.2742 38.6306 25.3865 36.084C26.6772 34.5789 28.5547 33.7691 30.4314 33.6527C32.4259 33.5373 34.3033 34.3471 35.8291 35.7359L39.8181 39.4404L30.9011 9.5759C30.3143 7.72365 30.5492 5.64048 31.4879 3.90375C32.4267 2.16778 34.0692 0.894359 35.9468 0.31559C37.8243 -0.263345 39.9358 -0.0316093 41.6962 0.894525C43.4559 1.82066 44.7467 3.44111 45.3333 5.29338L47.9146 13.9749C48.6185 13.5123 49.4402 13.0488 50.261 12.8171C52.1385 12.2381 54.2501 12.4699 56.0105 13.396C56.7144 13.7432 57.4182 14.3221 57.888 14.901C58.7097 14.0904 59.7655 13.5122 60.9384 13.1651C62.8159 12.5861 64.9275 12.8179 66.6879 13.744C67.7437 14.3229 68.5654 15.1328 69.2692 16.0589C70.0909 15.3645 70.9118 14.901 71.9676 14.6701C75.6047 13.8626 79.1249 15.5994 81.3544 19.4187L81.3551 19.4175ZM15.1799 50.7869C14.4761 49.629 12.9504 49.2818 11.7777 49.8607L10.1351 50.7869C13.5373 37.4756 19.1699 25.2052 26.9132 14.3244C27.7349 13.2828 27.3821 11.6622 26.3263 10.9679C25.2706 10.1573 23.6279 10.5053 22.9241 11.5469C14.828 22.8905 8.96144 35.7394 5.44148 49.6299L4.61976 48.2411C3.91589 47.0832 2.39025 46.736 1.21756 47.315C0.0439017 48.0094 -0.30801 49.5145 0.278796 50.6714L4.03384 57.1534C4.38577 57.8478 5.08963 58.195 5.79348 58.3113H6.14541C6.61438 58.3113 6.96713 58.1958 7.4361 57.9641L14.2414 54.0287C15.415 53.3335 15.884 51.9447 15.1801 50.7867L15.1799 50.7869Z"
            fill="#FFF"
          />
        </svg>
        <div class="swipe-prompt__instruction">{{ swipe_left_prompt }}</div>
      </template>
      <template v-else>
        <div class="swipe-prompt__left-arrow"></div>
        <div class="swipe-prompt__instruction">
          {{ swipe_left_prompt_short }}
        </div>
      </template>
    </div>
    <div class="swipe-prompt__right">
      <template v-if="!usingKeys">
        <svg class="swipe-prompt__right-hand" viewBox="0 0 88 80">
          <path
            d="M1.24041 21.5592C12.9338 13.8293 25.9012 8.44233 39.9104 5.39687L38.5213 4.57665C37.3632 3.87407 37.016 2.35121 37.7105 1.18067C38.405 0.00916251 39.9105 -0.342105 41.0676 0.360452L47.3193 4.34223C47.8983 4.69352 48.2456 5.27927 48.3611 5.865C48.4766 6.45076 48.3611 7.15333 48.0138 7.73907L43.8458 14.2974C43.383 15 42.5722 15.4689 41.7622 15.4689C41.2994 15.4689 40.8359 15.3521 40.4886 15.1176C39.3305 14.4151 38.9832 12.8922 39.6777 11.7217L40.6041 10.1989C27.1736 13.1268 14.6697 18.2802 3.55497 25.6588C3.09221 25.8932 2.62864 26.0101 2.28136 26.0101C1.47052 26.0101 0.660506 25.6588 0.197765 24.9562C-0.264191 23.7847 0.083084 22.2627 1.24039 21.5594L1.24041 21.5592ZM76.3806 28.1184C75.2225 27.6503 74.0653 27.5327 72.9071 27.5327C72.6753 24.8392 71.0544 22.2626 68.2763 21.091C67.4655 20.7397 66.54 20.6229 65.7292 20.5053L69.2028 12.0728C70.8236 8.20797 68.971 3.7571 65.1501 2.2352C61.3294 0.595605 56.9294 2.46967 55.4249 6.33473L43.6153 35.3798L42.9208 29.992C42.689 27.8843 41.6472 26.1271 40.1419 24.9564C38.6365 23.7849 36.6683 23.3168 34.7003 23.668C31.4585 24.2538 29.2587 27.5329 28.9114 32.1005V32.2173C28.9114 33.1543 27.7533 54.3524 32.3849 65.3615C32.7322 66.2985 33.6585 66.8842 34.5849 66.8842C34.9322 66.8842 35.164 66.7674 35.5113 66.6498C36.7849 66.1817 37.3639 64.6589 36.7849 63.4874C32.7322 53.7667 33.6586 33.3883 33.7748 32.5685C33.8903 30.5776 34.7012 28.8203 35.6275 28.7036C36.2065 28.5868 36.7856 28.7036 37.2483 29.0549C37.7111 29.4062 38.0592 29.9919 38.1747 30.8113L40.1428 45.334C40.2583 46.3879 41.1846 47.3249 42.2264 47.4417C43.2682 47.5586 44.4264 46.9736 44.7735 45.919L60.0567 8.32433C60.6357 7.036 62.1403 6.33345 63.4138 6.91918C64.6875 7.50493 65.382 9.02687 64.8029 10.3152L58.6667 25.3062L54.1513 36.3154C53.6886 37.6037 54.2668 39.0089 55.4249 39.4778C56.6985 39.9459 58.0876 39.3609 58.5511 38.1894L63.0665 27.1802C63.6456 25.8919 65.1501 25.1893 66.4237 25.775C67.1182 26.0095 67.5818 26.5953 67.8128 27.1802C68.0445 27.8828 68.0445 28.5854 67.8128 29.1711L66.5392 32.2159L62.9502 40.9997C62.4875 42.2881 63.0657 43.6932 64.2238 44.1621C64.5711 44.2789 64.8029 44.3966 65.1502 44.3966C66.0765 44.3966 67.0028 43.8108 67.3502 42.8738L70.9391 34.09C71.5182 32.8017 73.0227 32.0991 74.2963 32.6848C75.5699 33.2706 76.2644 34.7925 75.6853 36.0808L74.4117 39.1257C74.2963 39.2425 74.2963 39.3601 74.2963 39.5938C74.1808 39.8282 74.0645 40.0619 73.949 40.2963L72.0963 44.8639C71.6336 46.1522 72.2118 47.5574 73.3699 48.0263C74.6436 48.4944 76.0326 47.9095 76.4962 46.738L78.3488 42.1704C78.9279 40.8821 80.4324 40.1795 81.706 40.7652C83.2113 41.351 83.0951 43.4587 82.9796 44.5134C82.1687 46.7388 74.7589 67.9368 67.1181 75.7837C66.1918 76.7207 66.1918 78.3603 67.1181 79.2974C67.5809 79.7655 68.16 80 68.8545 80C69.4335 80 70.1281 79.7655 70.5908 79.2974C79.506 70.1623 87.3785 46.856 87.7258 45.919C87.7258 45.8022 87.8413 45.6846 87.8413 45.5677C88.5359 41.2346 86.915 37.6042 83.6733 36.3159C82.747 35.9646 81.7052 35.7301 80.6633 35.7301C81.1276 32.4525 79.3905 29.4079 76.3805 28.1194L76.3806 28.1184Z"
            fill="#FFF"
          />
        </svg>
        <div class="swipe-prompt__instruction">{{ swipe_right_prompt }}</div>
      </template>
      <template v-else>
        <div class="swipe-prompt__right-arrow"></div>
        <div class="swipe-prompt__instruction">
          {{ swipe_right_prompt_short }}
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { passiveEvent } from "@/scripts/globals.js";
import * as Input from "@/scripts/input.js";
import SessionData from "@/scripts/sessionData.js";

export default {
  data() {
    const {
      swipe_left_prompt,
      swipe_left_prompt_short,
      swipe_right_prompt,
      swipe_right_prompt_short,
    } = SessionData.lang.Interactions;

    return {
      visible: false,
      usingKeys: Input.mode === 2,
      swipe_left_prompt,
      swipe_left_prompt_short,
      swipe_right_prompt,
      swipe_right_prompt_short,
    };
  },
  methods: {
    show() {
      this.visible = true;
    },
    hide() {
      this.visible = false;
    },
    onKey(e) {
      if (
        e.key === "ArrowRight" ||
        e.key === "ArrowLeft" ||
        e.key === "Escape"
      ) {
        this.hide();
        Input.keyboardMode();
      }
    },
    modeChange() {
      this.usingKeys = Input.mode === 2;
    },
  },
  created() {
    window.addEventListener("touchstart", this.hide, passiveEvent);
    window.addEventListener("mousedown", this.hide);
    window.addEventListener("focusin", this.hide);
    window.addEventListener("keydown", this.onKey);
    window.addEventListener("wheel", this.hide);
    Input.addCallback(this.modeChange);
  },
  beforeUnmount() {
    window.removeEventListener("touchstart", this.hide, passiveEvent);
    window.removeEventListener("mousedown", this.hide);
    window.removeEventListener("focusin", this.hide);
    window.removeEventListener("keydown", this.onKey);
    window.removeEventListener("wheel", this.hide);
    Input.removeCallback(this.modeChange);
  },
};
</script>

<style lang="scss">
@keyframes left {
  0% {
    transform: translate(2rem, -50%);
    opacity: 0;
  }

  100% {
    transform: translateY(-50%);
    opacity: 1;
  }
}

@keyframes left-hand {
  0% {
    transform: rotate(0deg);
  }

  10% {
    transform: rotate(-10deg);
  }

  20% {
    transform: rotate(0deg);
  }

  30% {
    transform: rotate(-10deg);
  }

  40% {
    transform: rotate(0deg);
  }
}

@keyframes left-arrow {
  0% {
    transform: translateX(0);
  }
  5% {
    transform: translateX(-0.5rem);
  }
  10% {
    transform: translateX(0);
  }
  15% {
    transform: translateX(-0.5rem);
  }
  20% {
    transform: translateX(0);
  }
}

@keyframes right {
  0% {
    transform: translate(-2rem, -50%);
    opacity: 0;
  }

  100% {
    transform: translateY(-50%);
    opacity: 1;
  }
}

@keyframes right-hand {
  0% {
    transform: rotate(0deg);
  }

  10% {
    transform: rotate(10deg);
  }

  20% {
    transform: rotate(0deg);
  }

  30% {
    transform: rotate(10deg);
  }

  40% {
    transform: rotate(0deg);
  }
}

@keyframes right-arrow {
  0% {
    transform: translateX(0);
  }
  5% {
    transform: translateX(0.5rem);
  }
  10% {
    transform: translateX(0);
  }
  15% {
    transform: translateX(0.5rem);
  }
  20% {
    transform: translateX(0);
  }
}

.swipe-prompt {
  pointer-events: none;
  position: fixed;
  z-index: $z-modal;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);

  opacity: 0;
  transition: opacity 1s $ease-out-quad;

  &--show {
    opacity: 1;

    & > .swipe-prompt__left {
      animation: left 0.5s ease-out;
    }

    & > .swipe-prompt__right {
      animation: right 0.5s ease-out;
    }
  }

  &::before {
    content: "";
    position: absolute;
    top: 20%;
    bottom: 10%;
    left: 50%;
    border-left: dashed 4px #fff;
    margin: 0 0 0 -2px;
  }

  &__left {
    box-sizing: border-box;
    position: absolute;
    top: 50%;
    right: 50%;
    width: 0.5 * 85%;
    max-width: 0.5 * $container-width-lg;
    padding: 1rem;
    transform: translateY(-50%);
  }

  &__left-hand {
    display: block;
    width: 4rem;
    margin: 4rem * 80/88 - 4rem * 70/89 - 0.125rem auto 1.125rem;

    transform-origin: 70% 80%;
    animation: left-hand 3s ease-out infinite;
  }

  &__instruction {
    max-width: 10rem;
    margin: 0 auto;
    text-align: center;
    text-wrap: balance;
  }

  &__right {
    box-sizing: border-box;
    position: absolute;
    top: 50%;
    left: 50%;
    width: 0.5 * 85%;
    max-width: 0.5 * $container-width-lg;
    padding: 1rem;
    transform: translateY(-50%);
  }

  &__right-hand {
    display: block;
    width: 4rem;
    margin: 0 auto 1rem;

    transform-origin: 40% 80%;
    animation: right-hand 3s 1.5s ease-out infinite;
  }

  &__left-arrow,
  &__right-arrow {
    position: relative;
    display: block;
    width: 2rem;
    height: 2rem;
    margin: 0 auto;
    margin-bottom: 1rem;
    border: solid 0.125rem #fff;
    border-radius: 20%;

    &::before {
      content: "";
      position: absolute;
      top: 50%;
      left: 50%;
      border-top: solid 0.125rem #fff;
      border-right: solid 0.125rem #fff;
      width: 0.4rem;
      height: 0.4rem;
      transform: translate(-30%, -50%) rotate(-135deg);
    }
  }

  &__left-arrow {
    animation: left-arrow 3s ease-out infinite;
  }

  &__right-arrow {
    animation: right-arrow 3s ease-out infinite;

    &::before {
      transform: translate(-70%, -50%) rotate(45deg);
    }
  }
}
</style>
